/**
 * True when the current URL is a /terminal surface (including /setups, which
 * now serves the Terminal home).
 *
 * Several providers mounted app-wide — my picks, chart colours, TP/SL prefs —
 * fetch on mount for the legacy pages that consume them. No terminal component
 * reads any of them, so on these routes those requests are pure overhead. The
 * providers still mount (the tree is shared); they just skip the network call.
 *
 * Deliberately reads window.location rather than useLocation: this is called
 * from provider effects that sit ABOVE the router in the tree, where the hook
 * is unavailable. Providers re-check on navigation via a popstate listener
 * where it matters; for mount-once preference loads, the entry URL is enough.
 */
export default function onTerminalRoute() {
  try {
    const p = window.location?.pathname || '';
    return p === '/setups' || p === '/terminal' || p.startsWith('/terminal/');
  } catch {
    return false;
  }
}
